import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal, Button } from 'react-bootstrap';
import { FocusTrap } from 'focus-trap-react';
import { Icon, ICONS } from '../../Icons';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import * as Actions from '../../../redux/actions/index';
import './ManageFAQ.scss';
import FloatingInput from 'components/elements/atoms/FloatingInput/FloatingInput';
import Editor from 'components/elements/molecules/Editor/Editor';
import ActionLink from 'components/elements/molecules/ActionLink/ActionLink';
// import DropDown from 'components/elements/atoms/DropDown/DropDown';
// import classNames from 'classnames';
import { isValidUrl } from 'helpers/validation';

function ManageFAQ({ onClose, actions, faq, maxOrder }) {
  const [model, setModel] = useState({ ...faq, order: faq?.order ?? maxOrder });
  const [editLink, setEditLink] = useState(null);

  const orderOptions = useMemo(() => {
    let options = [];
    options = [...Array(maxOrder)].map((_, i) => ({
      label: i + 1,
      value: i + 1,
    }));
    return options;
  }, []);

  const onSave = async () => {
    if (model._id) {
      await actions.updateFAQ(model);
    } else {
      await actions.addFAQ(model);
    }
    onClose(model);
  };

  const validate = () => {
    if (!model.question || !model.answer || !model.order) {
      return false;
    }

    if (
      model.links &&
      model.links.length &&
      model.links.find((link) => !link.text || !link.url)
    ) {
      return false;
    }

    return true;
  };

  const renderLinks = () => {
    if (editLink) {
      return null;
    }

    if (!model.links || !model.links.length) {
      return <p className="mt-1 gray-4">No external links</p>;
    }

    return (
      <div className="links-list">
        {model.links.map((link, index) => {
          return (
            <div className="link-item">
              <div className="row">
                <div className="col-xs-4">
                  <Icon icon={ICONS.LINK_2} className="mr-3" size={12} />
                  {link.text}
                </div>
                <div className="col-xs-6">
                  {isValidUrl(link.url) ? (
                    <a href={link.url} target="_blank">
                      {link.url}
                    </a>
                  ) : (
                    link.url
                  )}
                </div>
                <div className="col-xs-2 text-center">
                  <ActionLink
                    linkClassName="av-blue"
                    iconType="averPointIcon"
                    iconName="PENCIL"
                    onClick={() => {
                      setEditLink({ ...link, index });
                    }}
                  />
                  <ActionLink
                    linkClassName="av-red"
                    iconType="averPointIcon"
                    iconName="DELETE"
                    onClick={() => {
                      model.links.splice(index, 1);
                      setModel({ ...model });
                    }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );

    // return (
    //   <table className="table table-bordered mt-3">
    //     <thead>
    //       <tr>
    //         <th>Text</th>
    //         <th>URL</th>
    //         <th>Actions</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       {model.links.map((link, index) => {
    //         return (
    //           <tr>
    //             <td>{link.text}</td>
    //             <td>{link.url}</td>
    //             <td>
    //               <ActionLink
    //                 linkClassName="av-blue"
    //                 iconType="averPointIcon"
    //                 iconName="PENCIL"
    //                 onClick={() => {
    //                   setEditLink({ ...link, index });
    //                 }}
    //               />
    //               <ActionLink
    //                 linkClassName="av-red"
    //                 iconType="averPointIcon"
    //                 iconName="DELETE"
    //                 onClick={() => {
    //                   model.links.splice(index, 1);
    //                   setModel({ ...model });
    //                 }}
    //               />
    //             </td>
    //           </tr>
    //         );
    //       })}
    //     </tbody>
    //   </table>
    // );
  };

  const renderManageLink = () => {
    if (!editLink) {
      return null;
    }

    return (
      <ManageExternalLink
        link={editLink}
        onAddEdit={(link) => {
          setEditLink(null);

          if (!link) {
            return;
          }

          if (!model.links) {
            model.links = [];
          }

          if (link.index === -1) {
            model.links.push({ text: link.text, url: link.url });
          } else {
            model.links.splice(link.index, 1, {
              text: link.text,
              url: link.url,
            });
          }

          setModel({ ...model });
        }}
      />
    );
  };

  const renderFAQ = () => {};

  return (
    <Modal show={true} className="manage-faq-modal">
      <FocusTrap>
        <div>
          <Modal.Header>
            <Modal.Title>
              {faq && faq._id ? 'Update' : 'Add'} an FAQ
            </Modal.Title>
            <Button bsStyle="link" className="btn-close" onClick={onClose}>
              <Icon icon={ICONS.CLOSE} className="mr-0" />
            </Button>
            <p className="mt-3 gray-4">
              {faq && faq._id
                ? 'Edit the question, answer and display order'
                : 'Help students find answers to common questions in your course'}
            </p>
          </Modal.Header>
          <Modal.Body>
            <label className="input-label">Question *</label>
            <FloatingInput
              autoFocus={true}
              value={model.question}
              // labelName="Question"
              onChange={(e) => {
                setModel({ ...model, question: e.target.value });
              }}
            />
            {/* <p className="mt-1 gray-4">This will appear as the FAQ title</p> */}
            <div className="divider"></div>
            <label className="input-label">Answer *</label>
            <Editor
              onChange={(text) => {
                setModel({ ...model, answer: text });
              }}
              html={model.answer}
              toolbar={{
                options: ['inline', 'list', 'link'],
                link: {
                  options: ['link', 'unlink'],
                  link: { className: 'toolbar-btn' },
                  unlink: { className: 'toolbar-btn' },
                },
                inline: {
                  options: ['bold', 'italic', 'underline'],
                  bold: {
                    className: 'toolbar-btn',
                  },
                  italic: {
                    className: 'toolbar-btn',
                  },
                  underline: {
                    className: 'toolbar-btn',
                  },
                },
                list: {
                  options: ['unordered', 'ordered', 'indent', 'outdent'],
                  unordered: {
                    className: 'toolbar-btn',
                  },
                  ordered: {
                    className: 'toolbar-btn',
                  },
                  indent: {
                    className: 'toolbar-btn',
                  },
                  outdent: {
                    className: 'toolbar-btn',
                  },
                },
              }}
              toolbarCustomButtons={[]}
            />
            <div className="divider"></div>
            <label className="input-label">Order *</label>
            <select
              className="form-control"
              value={model.order}
              onChange={(e) => setModel({ ...model, order: e.target.value })}
              style={{ maxWidth: '100px' }}
              disabled={orderOptions.length === 1}
            >
              {orderOptions.map((i) => (
                <option value={i.value}>{i.label}</option>
              ))}
            </select>
            <div className="divider"></div>
            <div className="d-flex align-items-center">
              <label className="input-label mb-0 mr-3">External Links</label>
              {!editLink ? (
                <ActionLink
                  onClick={() => {
                    setEditLink({ text: '', url: '', index: -1 });
                  }}
                  linkClassName="av-blue"
                  iconType="averPointIcon"
                  iconName="ADD"
                  label="Link"
                />
              ) : null}
            </div>
            {renderLinks()}
            {renderManageLink()}
            <div className="text-right">
              <RectangularButton
                className="next-button white-button mt-4"
                onClick={onClose}
              >
                Cancel
              </RectangularButton>
              <RectangularButton
                className="next-button ml-3 mt-4"
                disabled={!validate()}
                onClick={onSave}
              >
                Save Changes
              </RectangularButton>
            </div>
          </Modal.Body>
        </div>
      </FocusTrap>
    </Modal>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(ManageFAQ);

function ManageExternalLink({ link, onAddEdit }) {
  const [text, setText] = useState(link.text);
  const [url, setUrl] = useState(link.url);

  const renderEditMode = () => {
    return (
      <>
        <label className="input-label">Text *</label>
        <FloatingInput
          value={text}
          onChange={(e) => {
            setText(e.target.value);
          }}
        />
        <label className="input-label mt-2">URL *</label>
        <FloatingInput
          value={url}
          onChange={(e) => {
            setUrl(e.target.value);
          }}
        />
        <RectangularButton
          onClick={() => {
            onAddEdit();
          }}
          className="white-button mt-3"
          size="small"
        >
          Cancel
        </RectangularButton>
        <RectangularButton
          disabled={!link || !url}
          onClick={() => {
            onAddEdit({ text, url, index: link.index });
          }}
          size="small"
          className="ml-3"
        >
          {link.index === -1 ? 'Add' : 'Update'}
        </RectangularButton>
      </>
    );
  };

  return <div className="link-container my-3 p-3">{renderEditMode()}</div>;
}
